/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BrandPaymentResponse } from '../models/BrandPaymentResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BrandPaymentsService {
    /**
     * @param brandId
     * @param orderId
     * @returns BrandPaymentResponse OK
     * @throws ApiError
     */
    public static postApiBrandPayments(
        brandId: number,
        orderId: string,
    ): CancelablePromise<BrandPaymentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brand-payments/{brandId}/{orderId}',
            path: {
                'brandId': brandId,
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postApiBrandPaymentsCallback(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brand-payments/callback',
        });
    }
}
